import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { CONTEXT_HIGHLIGHT_STROKE_WIDTH } from './consts';

export const AxisLine = styled.path`
  fill: none;
  stroke: ${colors.grey300};
`;

export const AxisTick = styled.line`
  stroke: ${colors.grey300};
`;

const axisLabel = css`
  color: ${colors.grey900};
`;

export const XAxisLabel = styled.text`
  ${axisLabel}
  text-anchor: middle;
`;

export const YAxisLabel = styled.text`
  ${axisLabel}
  text-anchor: end;
`;

export const AxisTitle = styled.text`
  text-anchor: middle;
  dominant-baseline: middle;
`;

export const BubbleChartViewContainer = styled.div`
  & .rotate-270 {
    transform: rotate(270deg);
  }
`;
export const BubbleChartContainer = styled.div`
  height: 100%;
  position: relative;
  & g.dataPoint {
    transition-property: opacity;
    transition-duration: 100ms;
  }
  & circle.dataPoint {
    opacity: 0.5;
    stroke-opacity: 0.7;
  }
  & circle.dataPoint.blurred {
    opacity: 0.1;
  }
  & circle.dataPointContextHighlight {
    stroke-width: ${CONTEXT_HIGHLIGHT_STROKE_WIDTH};
    stroke: ${colors.blue400};
    fill: none;
  }
  & text.dataPointLabel {
    user-select: none;
  }
  & svg:not(.forExport) text.dataPointLabel {
    @keyframes pointerEventsDelay {
      0% {
        pointer-events: none;
        opacity: 0;
      }
      100% {
        pointer-events: auto;
        opacity: 1;
      }
    }
    animation: 500ms linear 0s pointerEventsDelay;
  }
`;
export const BubbleChartSvgElement = styled.svg`
  display: block;
`;

export const QuadrantLabelText = styled.text`
  text-anchor: middle;
  dominant-baseline: middle;
  fill: ${colors.grey400};
  font-size: 32px;
  opacity: 0.5;
`;
export const TimeLine = styled.line`
  stroke-width: 1px;
  clip-path: url(#chartAreaClipPath);
  stroke: ${colors.grey300};
`;
